type Listener = {
    event: string;
    fn: (...args: any[]) => any;
    context?: any;
    once: boolean;
};

export default class Pevents {
    private listeners: Listener[] = [];

    private addListener(event: string, fn: (...args: any[]) => any, context?: any, once: boolean = false): void {
        if (typeof fn !== 'function') {
            throw new TypeError('The listener must be a function');
        }

        const existing = this.listeners.find((l) => l.event === event && l.fn === fn && l.context === context);
        if (existing) return;

        this.listeners.push({ event, fn, context, once });
    }

    private removeListener(event: string, fn: (...args: any[]) => any, context?: any): void {
        const matches = this.listeners.filter((l) => l.event === event && l.fn === fn && l.context === context);
        matches.forEach((entry) => {
            const index = this.listeners.indexOf(entry);
            if (index !== -1) this.listeners.splice(index, 1);
        });
    }

    on(event: string, fn: (...args: any[]) => any, context?: any): void {
        this.addListener(event, fn, context, false);
    }

    once(event: string, fn: (...args: any[]) => any, context?: any): void {
        this.addListener(event, fn, context, true);
    }

    off(event: string, fn: (...args: any[]) => any, context?: any): void {
        this.removeListener(event, fn, context);
    }

    async emit(event: string, ...args: any[]): Promise<any[]> {
        const matches = this.listeners.filter((l) => l.event === event);
        const jobs = matches.map((entry) => entry.fn.call(entry.context, ...args));

        const result = await Promise.all(jobs);

        matches.forEach((entry) => {
            if (entry.once) {
                this.removeListener(entry.event, entry.fn, entry.context);
            }
        });

        return result;
    }
}
